module.exports = "/images/mmo-wellness-center.png?f9e4ce2422bc97fe5b35e2704e39a1d6";